// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})


const pageHome = document.querySelector('.home');
if(pageHome){
    //Home tabs dropdown
    let listCheckCommunes = document.querySelectorAll('.communes__check');
    
    let checkOne = document.getElementById('communes__labelOne');
    let checkTwo = document.getElementById('communes__labelTwo');
    
    let selectOne = document.getElementById('list-eau');
    let selectTwo = document.getElementById('list-assainissement');
    
    checkOne.parentNode.classList.add('js-selected');
    checkTwo.addEventListener('click',function(){
        checkOne.parentNode.classList.remove('js-selected');
        checkTwo.parentNode.classList.add('js-selected');
    })
    checkOne.addEventListener('click',function(){
        checkTwo.parentNode.classList.remove('js-selected');
        checkOne.parentNode.classList.add('js-selected');
    })
    
    //Home tabs dropdown keydown enter
    let inputOne = document.getElementById('communes__btn--1');
    let inputTwo = document.getElementById('communes__btn--2');
    inputOne.addEventListener('keydown',(e) =>{
        if (e.key === 'Enter') {
            checkTwo.parentNode.classList.remove('js-selected');
            checkOne.parentNode.classList.add('js-selected');
          }
    
    })
    inputTwo.addEventListener('keydown',(e) =>{
        if (e.key === 'Enter') {
            checkOne.parentNode.classList.remove('js-selected');
            checkTwo.parentNode.classList.add('js-selected');
          }
    })
}